function SubscriptionWarningBanner({ isDarkMode, redirecting, onManageSubscription, isOwner }) {
	return (
		<div
			className={`mx-auto rounded-lg p-4 w-fit ${
				isDarkMode
					? 'bg-orange-500/10 border border-orange-500/20'
					: 'bg-orange-50 border border-orange-200'
			}`}
		>
			<div className="flex items-center gap-3">
				<div className="flex items-center gap-3">
					<svg
						className={`h-5 w-5 ${
							isDarkMode ? 'text-orange-400' : 'text-orange-600'
						}`}
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
						/>
					</svg>
					<h3
						className={`text-sm font-medium ${
							isDarkMode ? 'text-orange-400' : 'text-orange-800'
						}`}
					>
						Team Subscription Inactive
					</h3>
				</div>
				{isOwner && (
					<button
						onClick={onManageSubscription}
						disabled={redirecting}
						className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
							isDarkMode
								? 'bg-orange-600 hover:bg-orange-500 text-white'
								: 'bg-orange-600 hover:bg-orange-700 text-white'
						} disabled:opacity-50 disabled:cursor-not-allowed`}
					>
						{redirecting ? 'Redirecting...' : 'Manage Subscription'}
					</button>
				)}
			</div>
		</div>
	)
}

export default SubscriptionWarningBanner
